import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProfileVisibility from "./ProfileVisibility";
import CompanyInformation from "./CompanyInformation";
import SecurityInformation from "./Security";
import EmailInformation from "./Email";
import TradeComodity from "./TradeComodity";
import BuyerFaq from "./Faq";
const BuyerProfileModule = () => {
    const [activeTab, setActiveTab] = useState("Profile & Visibility");

    const navigate = useNavigate();
    const tabs = ["Profile & Visibility", "Company Information", "Email", "Security", "Trade commodity", "FAQ"];
    const renderTabContent = () => {
        switch (activeTab) {
            case "Profile & Visibility":
                return <ProfileVisibility />;
            case "Company Information":
                return <CompanyInformation />;
            case "Security":
                return <SecurityInformation />;
            case "Email":
                return <EmailInformation />;
            case "Trade commodity":
                return <TradeComodity />;
            case "FAQ" : return <BuyerFaq/>;
            default:
                <ProfileVisibility />

        }
    };
    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab
                                        ? "active"
                                        : "notactive"
                                        }`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default BuyerProfileModule;